import { Component, Input, OnInit, forwardRef } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { CareerDao } from '@app/dao/career/career.dao';
import { ReferenceDao } from '@app/dao/reference/reference.dao';
import { UserDao } from '@app/dao/user/user.dao';
import { PrProfessionFormBuilder } from '../ea-profession-form/ea-profession-form.builder';
import { combineLatest } from 'rxjs';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { EaProfessionFormComponent } from '../ea-profession-form/ea-profession-form.component';

@Component({
    selector: 'ea-choose-form',
    templateUrl: './ea-choose-form.component.html',
    styleUrls: ['./ea-choose-form.component.scss'],
    providers: [
        {
            provide: PrFormAbstract,
            useExisting: forwardRef(() => EaChooseFormComponent),
        },
    ],
    standalone: false
})
export class EaChooseFormComponent extends PrProfessionFormBuilder {
  form: any;

  constructor(protected formConstructor: PrFormConstructor) {
    super(formConstructor);
  }

  title: string = 'Nouveau revenu';

  onSubmit() {}

  startForm(type) {
    this.prFormService.open(EaProfessionFormComponent, {
      accountId: this.form.value.accountId,
      type: type,
    });
  }
}
